<template>
    <div class="main">
        <div class="outmain bg-white">
            <div class="shuju_title mar_b20">
                <div class="shuju_title_text">
                    <span>营销列表</span>
                </div>
            </div>
            <div class="market mar_b30">
                <div class="mtitle color_3 fon_16">店铺营销</div>
                <div class="market-con clearfix">
                    <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs" @click="app('coupon')">
                        <div class="item-wrapper ba_f57a flex rel">
                            <div class="pic">
                                <img src="@/assets/images/coupon.png" class="dis_bk">
                            </div>
                            <div class="description flex-1 mar_l15">
                                <div class="overflowlnr fon_16 color_3">
                                    优惠券
                                </div>
                                <div class="overflowlnr fon_12 color_9 mar_t5">使用优惠券，购物有优惠</div>
                            </div>
                        </div>
                    </div>
                    <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs" @click="app('manjian')">
                        <div class="item-wrapper ba_f57a flex rel">
                            <div class="pic">
                                <img src="@/assets/images/manjian.png" class="dis_bk">
                            </div>
                            <div class="description flex-1 mar_l15">
                                <div class="overflowlnr fon_16 color_3">
                                    满减活动
                                </div>
                                <div class="overflowlnr fon_12 color_9 mar_t5">满减活动</div>
                            </div>
                        </div>
                    </div>
                    <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs" @click="app('mansong')">
                        <div class="item-wrapper ba_f57a flex rel">
                            <div class="pic">
                                <img src="@/assets/images/mansong.png" class="dis_bk">
                            </div>
                            <div class="description flex-1 mar_l15">
                                <div class="overflowlnr fon_16 color_3">
                                    满送活动
                                </div>
                                <div class="overflowlnr fon_12 color_9 mar_t5">满送活动</div>
                            </div>
                        </div>
                    </div>
                    <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs" @click="app('seckill')">
                        <div class="item-wrapper ba_f57a flex rel">
                            <div class="pic">
                                <img src="@/assets/images/seckill.png" class="dis_bk">
                            </div>
                            <div class="description flex-1 mar_l15">
                                <div class="overflowlnr fon_16 color_3">
                                    限时秒杀
                                </div>
                                <div class="overflowlnr fon_12 color_9 mar_t5">限时秒杀</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="market mar_b30">
                <div class="mtitle color_3 fon_16">会员营销</div>
                <div class="market-con clearfix">
                    <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs" @click="app('dealer')">
                        <div class="item-wrapper ba_f57a flex rel">
                            <div class="pic">
                                <img src="@/assets/images/dealer.png" class="dis_bk">
                            </div>
                            <div class="description flex-1 mar_l15">
                                <div class="overflowlnr fon_16 color_3">
                                    分销
                                </div>
                                <div class="overflowlnr fon_12 color_9 mar_t5">分销活动</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="market mar_b30">
                <div class="mtitle color_3 fon_16">客群维护</div>
                <div class="market-con clearfix">
                    <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs" @click="app('points')">
                        <div class="item-wrapper ba_f57a flex rel">
                            <div class="pic">
                                <img src="@/assets/images/points.png" class="dis_bk">
                            </div>
                            <div class="description flex-1 mar_l15">
                                <div class="overflowlnr fon_16 color_3">
                                    积分管理
                                </div>
                                <div class="overflowlnr fon_12 color_9 mar_t5">积分设置</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",
        methods: {
            app: function (app) {
                switch (app) {
                    case 'coupon':
                        this.$router.push({
                            path: '/app/coupon/list.html'
                        });
                        break;
                    case 'manjian':
                        this.$router.push({
                            path: '/app/manjian/list.html'
                        });
                        break;
                    case 'mansong':
                        this.$router.push({
                            path: '/app/mansong/list.html'
                        });
                        break;
                    case 'seckill':
                        this.$router.push({
                            path: '/app/seckill/list.html'
                        });
                        break;
                    case 'dealer':
                        this.$router.push({
                            path: '/app/dealer/user.html'
                        });
                        break;
                    case 'points':
                        this.$router.push({
                            path: '/app/points/setting.html'
                        });
                        break;
                }
            }
        }
    }
</script>

<style scoped>
    .el-container {
        background: #f5f7f9;
    }

    .shuju_title {
        position: relative;
        padding: 10px;
        width: 100%;
        min-height: 40px;
        background-color: #f8f8f8;
    }
    .shuju_title .shuju_title_text {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        padding-left: 7px;
        font-size: 14px;
        font-weight: 700;
        color: #353535;
        line-height: 20px;
    }
    .shuju_title .shuju_title_text:before {
        position: absolute;
        top: 50%;
        left: -3px;
        transform: translateY(-50%);
        margin-right: 5px;
        content: "";
        display: inline-block;
        height: 14px;
        width: 3px;
        background-color: #155bd4;
    }
    .flex, .flex-bet {
        display: flex;
        align-items: center;
    }
    .flex-1 {
        flex: 1;
        -webkit-box-flex: 1;
        -ms-flex: 1;
    }
    .market .mtitle{
        height: 30px;
        line-height: 30px;
    }
    .market-con{
        margin-right: -15px;
    }
    .market-con .item-wrapper{
        padding: 0 10px 0 15px;
        height: 80px;
        border-radius: 6px;
    }
    .item-wrapper:hover {
        box-shadow: 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12), 0 3px 5px -1px rgba(0,0,0,.11);
    }
    .pic img{
        width: 42px;
        height: 42px;
    }
    .wid17{
        width: 16%;
        transition: all .2s ease;
    }
    .ba_f57a {
        background: #f5f7fa;
    }
</style>
